(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.dataset.open = 'true';
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.dataset.open = 'false';
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?section_id=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var updated = doc.querySelector('[data-cart-drawer]');
        if (updated && drawer) {
          var wasOpen = drawer.dataset.open === 'true';
          drawer.innerHTML = updated.innerHTML;
          drawer.dataset.open = wasOpen ? 'true' : 'false';
        }
        return fetch('/cart.js');
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        reconcileQuantities();
        return cart;
      });
  }

  window.DalilCart = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-open]')) {
      event.preventDefault();
      refreshDrawer().then(openDrawer);
    }
    if (event.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
      closeQuickView();
      closeMobileMenu();
    }
  });

  function setSubmitBusy(form, busy) {
    var submitEl = form.querySelector('[data-add-to-cart-form-submit], button[type="submit"]');
    if (submitEl) submitEl.disabled = busy;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-add-to-cart-form], form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();
    setSubmitBusy(form, true);

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status) {
          console.error(data.description);
          return;
        }
        return refreshDrawer().then(openDrawer);
      })
      .finally(function () {
        setSubmitBusy(form, false);
      });
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-quick-add]');
    if (!btn) return;
    event.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        return refreshDrawer().then(openDrawer);
      })
      .finally(function () {
        btn.disabled = false;
      });
  });

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        return refreshDrawer();
      });
  }

  // Reflects a stepper's max attribute (the variant's real inventory_quantity,
  // rendered server-side) onto the "+" button's disabled state, so the button
  // stays in sync after client-side clicks/typing without waiting on a re-render.
  function syncQtyStepper(stepper) {
    if (!stepper) return;
    var input = stepper.querySelector('[data-qty-input]');
    var incBtn = stepper.querySelector('[data-qty-increase]');
    if (!input || !incBtn) return;
    var maxAttr = input.getAttribute('max');
    if (maxAttr === null || maxAttr === '') {
      incBtn.disabled = false;
      return;
    }
    var max = parseInt(maxAttr, 10);
    var value = parseInt(input.value, 10) || 0;
    incBtn.disabled = !isNaN(max) && value >= max;
  }

  // Scans every quantity input tied to a real cart line for a value that
  // exceeds its rendered max (the variant's live inventory_quantity) and
  // corrects it via the existing /cart/change.js path — covers a line that
  // was already in the cart before inventory dropped (e.g. two tabs, or
  // inventory reduced after the item was added).
  function reconcileQuantities() {
    var corrections = [];
    var seenLines = {};
    document.querySelectorAll('[data-qty-input][max]').forEach(function (input) {
      var stepper = input.closest('[data-quantity-stepper]');
      var line = stepper ? stepper.getAttribute('data-line') : null;
      if (!line) return;
      var max = parseInt(input.getAttribute('max'), 10);
      if (isNaN(max)) return;
      var value = parseInt(input.value, 10) || 0;
      if (value > max) {
        input.value = max;
        syncQtyStepper(stepper);
        if (!seenLines[line]) {
          seenLines[line] = true;
          corrections.push({ line: line, quantity: max });
        }
      }
    });

    if (!corrections.length) return;

    var chain = Promise.resolve();
    corrections.forEach(function (correction) {
      chain = chain.then(function () {
        return changeLine(correction.line, correction.quantity);
      });
    });
    chain.then(function () {
      if (document.querySelector('[data-cart-page]')) {
        window.location.reload();
      }
    });
  }

  document.addEventListener('click', function (event) {
    var incBtn = event.target.closest('[data-qty-increase]');
    var decBtn = event.target.closest('[data-qty-decrease]');
    if (!incBtn && !decBtn) return;

    var stepper = (incBtn || decBtn).closest('[data-quantity-stepper]');
    var input = stepper.querySelector('[data-qty-input]');
    var maxAttr = input.getAttribute('max');
    var max = maxAttr !== null && maxAttr !== '' ? parseInt(maxAttr, 10) : null;
    var value = parseInt(input.value, 10) || 0;
    value = incBtn ? value + 1 : Math.max(0, value - 1);
    if (max !== null && !isNaN(max) && value > max) value = max;
    input.value = value;
    syncQtyStepper(stepper);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Clamps a directly typed quantity as the customer types, so a value
  // above the variant's real inventory can never be left in the field.
  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-qty-input]');
    if (!input) return;
    var maxAttr = input.getAttribute('max');
    if (maxAttr === null || maxAttr === '') return;
    var max = parseInt(maxAttr, 10);
    if (isNaN(max)) return;
    var value = parseInt(input.value, 10);
    if (!isNaN(value) && value > max) {
      input.value = max;
    }
    syncQtyStepper(input.closest('[data-quantity-stepper]'));
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-qty-input]');
    if (!input) return;
    var stepper = input.closest('[data-quantity-stepper]');
    var line = stepper.getAttribute('data-line');
    if (!line) return;
    var maxAttr = input.getAttribute('max');
    var quantity = parseInt(input.value, 10) || 0;
    if (maxAttr !== null && maxAttr !== '') {
      var max = parseInt(maxAttr, 10);
      if (!isNaN(max) && quantity > max) {
        quantity = max;
        input.value = max;
      }
    }
    changeLine(line, quantity);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-quantity-stepper]').forEach(syncQtyStepper);
    reconcileQuantities();
  });

  document.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    event.preventDefault();
    changeLine(removeBtn.getAttribute('data-line'), 0);
  });

  function closeMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    if (menu) menu.dataset.open = 'false';
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-mobile-menu-toggle]');
    if (!toggle) return;
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    var isOpen = menu.dataset.open === 'true';
    menu.dataset.open = isOpen ? 'false' : 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });

  function setColorMode(mode) {
    document.documentElement.setAttribute('data-theme', mode);
    try {
      localStorage.setItem('dalilshop:color-mode', mode);
    } catch (e) {}
  }

  function syncThemeToggleLabel() {
    var toggle = document.querySelector('[data-theme-toggle]');
    if (!toggle) return;
    var isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    var label = isDark ? toggle.getAttribute('data-label-light') : toggle.getAttribute('data-label-dark');
    if (label) toggle.setAttribute('aria-label', label);
  }

  document.addEventListener('DOMContentLoaded', syncThemeToggleLabel);

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-theme-toggle]');
    if (!toggle) return;
    var isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    setColorMode(isDark ? 'light' : 'dark');
    syncThemeToggleLabel();
  });

  var header = document.querySelector('[data-site-header]');
  if (header) {
    var scrolledState = false;
    var updateHeaderState = function () {
      var scrolled = window.scrollY > 20;
      if (scrolled !== scrolledState) {
        header.dataset.scrolled = scrolled ? 'true' : 'false';
        scrolledState = scrolled;
      }
    };
    window.addEventListener('scroll', updateHeaderState, { passive: true });
    updateHeaderState();
  }

  var quickViewModal = document.querySelector('[data-quick-view-modal]');

  function closeQuickView() {
    if (!quickViewModal) return;
    quickViewModal.dataset.open = 'false';
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    var isArabic = document.documentElement.lang === 'ar';
    var value = (cents / 100).toFixed(2);
    return isArabic ? value + ' ' + 'ر.س' : 'SAR ' + value;
  }

  function renderQuickView(product) {
    quickViewModal.dataset.loading = 'false';
    var variant = product.variants[0];
    var image = quickViewModal.querySelector('[data-qv-image]');
    var titleLink = quickViewModal.querySelector('[data-qv-title]');
    var fullLink = quickViewModal.querySelector('[data-qv-full-link]');
    var price = quickViewModal.querySelector('[data-qv-price]');
    var form = quickViewModal.querySelector('[data-qv-form]');
    var optionsWrap = quickViewModal.querySelector('[data-qv-options]');

    if (image) {
      image.src = (product.featured_image || product.images[0] || '').replace('.jpg', '_600x.jpg');
      image.alt = product.title;
    }
    if (titleLink) {
      titleLink.textContent = product.title;
      titleLink.setAttribute('href', '/products/' + product.handle);
    }
    if (fullLink) {
      fullLink.setAttribute('href', '/products/' + product.handle);
    }
    if (price) price.textContent = formatMoney(variant.price);
    if (form) {
      form.querySelector('input[name="id"]').value = variant.id;
      form.setAttribute('data-product-url', '/products/' + product.handle);
    }

    if (optionsWrap) {
      optionsWrap.innerHTML = '';
      if (!product.has_only_default_variant) {
        optionsWrap.hidden = false;
        product.variants.forEach(function (v) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'qv-variant-btn';
          btn.textContent = v.title;
          btn.disabled = !v.available;
          btn.addEventListener('click', function () {
            form.querySelector('input[name="id"]').value = v.id;
            if (price) price.textContent = formatMoney(v.price);
            optionsWrap.querySelectorAll('.qv-variant-btn').forEach(function (b) {
              b.classList.remove('is-active');
            });
            btn.classList.add('is-active');
          });
          optionsWrap.appendChild(btn);
        });
        var firstAvailable = optionsWrap.querySelector('.qv-variant-btn:not([disabled])');
        if (firstAvailable) firstAvailable.classList.add('is-active');
      } else {
        optionsWrap.hidden = true;
      }
    }
  }

  function openQuickView(handle) {
    if (!quickViewModal) return;
    quickViewModal.dataset.open = 'true';
    quickViewModal.dataset.loading = 'true';
    document.body.style.overflow = 'hidden';

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        return res.json();
      })
      .then(renderQuickView)
      .catch(function () {
        closeQuickView();
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-view-trigger]');
    if (trigger) {
      event.preventDefault();
      openQuickView(trigger.getAttribute('data-product-handle'));
    }
    if (event.target.closest('[data-quick-view-close]')) {
      closeQuickView();
    }
  });

  function formatMoneyDecimal(cents) {
    var isArabic = document.documentElement.lang === 'ar';
    var value = (cents / 100).toFixed(2);
    return isArabic ? value + ' ' + 'ر.س' : 'SAR ' + value;
  }

  function getVariantInventory(scope, variantId) {
    var invEl = scope.querySelector('[data-variant-inventory-json]');
    if (!invEl) return null;
    try {
      var data = JSON.parse(invEl.textContent);
      return data[variantId] || null;
    } catch (e) {
      return null;
    }
  }

  function updateVariantUI(scope, variant) {
    if (!variant) return;

    var idInput = scope.querySelector('input[name="id"]');
    if (idInput) idInput.value = variant.id;

    var priceAmount = scope.querySelector('[data-product-price] .price__amount');
    var priceCompare = scope.querySelector('[data-product-price] .price__compare');
    if (priceAmount) priceAmount.textContent = formatMoneyDecimal(variant.price);
    if (priceCompare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceCompare.textContent = formatMoneyDecimal(variant.compare_at_price);
        priceCompare.hidden = false;
      } else {
        priceCompare.hidden = true;
      }
    }

    var inventory = getVariantInventory(scope, variant.id);
    var tracked = inventory ? inventory.tracked : false;
    var qty = inventory ? inventory.quantity : 0;

    var submitBtn = scope.querySelector('[data-add-to-cart-form-submit]');
    var availabilityEl = scope.querySelector('[data-variant-availability]');
    if (submitBtn) submitBtn.disabled = !variant.available;
    if (availabilityEl) {
      var textEl = availabilityEl.querySelector('[data-variant-availability-text]');
      var isOut = tracked && qty <= 0;
      var isLow = tracked && qty > 0 && qty < 10;
      var text;
      if (isOut) {
        text = availabilityEl.getAttribute('data-out-of-stock-text');
      } else if (isLow) {
        var template = availabilityEl.getAttribute('data-low-stock-template');
        text = template
          ? template.replace('COUNT_PLACEHOLDER', String(qty))
          : availabilityEl.getAttribute('data-out-of-stock-text');
      } else if (variant.available) {
        text = availabilityEl.getAttribute('data-in-stock-text');
      } else {
        text = availabilityEl.getAttribute('data-out-of-stock-text');
      }
      if (textEl) textEl.textContent = text;
      availabilityEl.classList.toggle('product-detail__availability--low', isLow || isOut);
    }

    // Keep the pre-cart quantity stepper capped to this variant's own real
    // inventory_quantity, independently of whichever variant was selected before.
    var qtyStepper = scope.querySelector('[data-quantity-stepper]');
    if (qtyStepper) {
      var qtyInput = qtyStepper.querySelector('[data-qty-input]');
      if (qtyInput) {
        if (tracked) {
          var maxQty = qty < 0 ? 0 : qty;
          qtyInput.setAttribute('max', String(maxQty));
          var currentQty = parseInt(qtyInput.value, 10) || 0;
          if (currentQty > maxQty) qtyInput.value = maxQty;
        } else {
          qtyInput.removeAttribute('max');
        }
        syncQtyStepper(qtyStepper);
      }
    }

    if (variant.featured_image && variant.featured_image.src) {
      var mainImg = scope.querySelector('[data-product-gallery-main]');
      if (mainImg) {
        var src = variant.featured_image.src;
        mainImg.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1000';
      }
    }
  }

  document.addEventListener('click', function (event) {
    var optionBtn = event.target.closest('[data-variant-option]');
    if (!optionBtn) return;

    var picker = optionBtn.closest('[data-variant-picker]');
    var position = optionBtn.getAttribute('data-option-position');
    picker.querySelectorAll('[data-option-position="' + position + '"]').forEach(function (btn) {
      btn.classList.remove('is-active');
    });
    optionBtn.classList.add('is-active');

    var scope = optionBtn.closest('[data-product-form-scope]');
    if (!scope) return;

    var jsonEl = scope.querySelector('[data-variant-json]');
    if (!jsonEl) return;
    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var groups = picker.querySelectorAll('.variant-picker__group');
    var selectedOptions = [];
    groups.forEach(function (group) {
      var active = group.querySelector('.variant-picker__value.is-active');
      if (active) selectedOptions.push(active.getAttribute('data-option-value'));
    });

    var match = variants.find(function (v) {
      return v.options.length === selectedOptions.length && v.options.every(function (opt, i) {
        return opt === selectedOptions[i];
      });
    });

    if (match) updateVariantUI(scope, match);
  });
})();
